import { Engine1Proxy, ConciergeProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_DATOS_GENERALES_CUENTA = "GET_DATOS_GENERALES_CUENTA";


let _tarjetas;
let _dispatch;
let _cuenta;
let _empresaSeleccionada;
let _cartera;
let userFunctions = [];
let userFeatures = [];
let _ultimaNovedad

/**
 * 
 * @param {any} id
 * @param {any} currentScope
 * @param {any} cuenta
 */
export function getScreenData(currentScope/*, id*/) {
    LogHelper.In(getScreenData.name, currentScope/*, id*/);



    const { UserId, ProductCode, CategoryCode, ProgramCode } = currentScope;

    return (dispatch, getState) => {

        Engine1Proxy.AddDataSourcesRequests(null, 'GET_SUCURSALES_ACTIVAS', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true, null);
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_GRUPO_AFINIDAD_ADMINISTRADORA_ACTIVOS', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true, null);

        Engine1Proxy.Execute((data) => _loadScreenData(data), null, null, "PARAMETRIA");
        
        _dispatch({ type: GET_DATOS_GENERALES_CUENTA });


    }
}
